import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: null,
    loading: false,
    data:''
} 

export const HelpAndFeedBackReducer = createSlice({
    name: 'helpAndFeedBackReducer',
    initialState,
    reducers: {
        initiateLoading: (state) => {
          state.loading = true
         },
        addHelpSuccess: (state, action) => {
           state.loading = false;
            state.data = action.payload;
        },
        addHelpFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload
        },
        resetData:(state,action)=>{
            state.loading = false;
            state.data = ''; 
        }
    }
});

export const { addHelpSuccess, addHelpFailure,initiateLoading,resetData} = HelpAndFeedBackReducer.actions;

// Selectors
export const getHelpAndFeedbackReducer = (state) => {
    return state.helpAndFeedBackReducer;
};

export default HelpAndFeedBackReducer.reducer;
